export enum PinToRouteAction {
  PINNED = "PINNED",
  UNPINNED = "UNPINNED",
}
